import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';
import { useParams } from "react-router-dom";
import './staticContentPage.css'
import { Helmet } from 'react-helmet';

export const COOKIE_POLICY = "cookiePolicy"
export const PRIVACY_POLICY = "privacyPolicy"
export const REFUND_POLICY = "refundPolicy"
export const TERMS_Of_SERVICE = "termsOfService"
export const ABOUT = "about"


export const StaticContentPage = ({optionalPageType} : { optionalPageType: string | null}) => {
  const { pageType } = useParams<{ pageType: string }>();
  const [termsMd, setTermsMd] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    const effectivePageType = pageType || optionalPageType;

    if (effectivePageType === COOKIE_POLICY) {
      fetch('/legal/md/CookiePolicy.md')
        .then(res => res.text())
        .then(setTermsMd);
      setTitle("Cookie Policy | Eco Eats")
      setDescription("Find out how Eco Eats uses cookies to improve your browsing experience, personalize content, and analyze traffic on our food platform.")
    } else if (effectivePageType === PRIVACY_POLICY) {
      fetch('/legal/md/PrivacyPolicy.md')
        .then(res => res.text())
        .then(setTermsMd);
      setTitle("Privacy Policy | Eco Eats")
      setDescription("Your privacy matters. Read how Eco Eats collects, uses, and protects your personal data when you use our e-commerce platform.")
    } else if (effectivePageType === REFUND_POLICY) {
      fetch('/legal/md/RefundPolicy.md')
        .then(res => res.text())
        .then(setTermsMd);
      setTitle("Refund Policy | Eco Eats")
      setDescription("Learn how Eco Eats handles refunds for food orders. Read our policy on cancellations, missed pickups, and partner-related issues.")
    } else if (effectivePageType === TERMS_Of_SERVICE) {
      fetch('/legal/md/ServicePolicy.md')
        .then(res => res.text())
        .then(setTermsMd);
      setTitle("Terms of Service | Eco Eats")
      setDescription("Review the terms and conditions for using Eco Eats. This includes customer responsibilities, order rules, and partner obligations.")
    } else if (effectivePageType === ABOUT) {
      fetch('/static/md/About.md')
        .then(res => res.text())
        .then(setTermsMd);
      setTitle("About Eco Eats | Conscious Food That Makes a Difference")
      setDescription("Discover Eco Eats - South Africa's marketplace for conscious food. Support local, eat well, and enjoy delicious meals from restaurants and stores near you.")
    }
  }, [pageType, optionalPageType]);
  return (
    <div className="pat prose max-w-none p-4 mx-auto p16">
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content={description}
        />
        <meta
          name="image"
          content="/src_assets/drawer_logo.svg"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />


        {/* <!-- Open Graph Tags --> */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/src_assets/drawer_logo.svg" />

        {/* <!-- Twitter Card Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/src_assets/drawer_logo.svg" />
      </Helmet>
      <div style={{ fontFamily: "Lato, sans-serif" }}>
        <ReactMarkdown
          children={termsMd}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeSanitize]}
        />
      </div>
    </div >
  );
}
